var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3502 4.5L12.001 9.588L4.65248 4.5H19.3502ZM7.50098 16.5H3.00098L2.99873 5.1795L11.5742 11.1165C11.7025 11.2058 11.8517 11.25 12.001 11.25C12.151 11.25 12.2995 11.2058 12.4285 11.1165L21.0017 5.18175L21.001 12H22.501V4.5C22.501 3.67275 21.8282 3 21.001 3H3.00098C2.17448 3 1.50098 3.6705 1.50098 4.497V16.5C1.50098 17.3273 2.17448 18 3.00098 18H7.50098V16.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.5L17.6895 14.5605L19.6252 16.5H13.5C11.8455 16.5 10.5 17.8455 10.5 19.5C10.5 21.1545 11.8455 22.5 13.5 22.5H15V21H13.5C12.6727 21 12 20.3273 12 19.5C12 18.6727 12.6727 18 13.5 18H19.6252L17.688 19.9402L18.75 21L22.5 17.25L18.75 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignReply);
export default __webpack_public_path__ + "static/media/campaign-reply.fb1cbaf0af52b708c70b029e34c2598f.svg";
export { ForwardRef as ReactComponent };